// maomi/src/components/MyCats.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, message } from 'antd';
import CatRegistration from './CatRegistration';
import CatModification from './CatModification';
import CatIDCard from '../pages/CatIDCard';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { API_BASE_URL } from '../config/api';
import { get, isAuthenticated } from '../utils/api';
import './css/MyCats.css';
import GradientButton from '../components/GradientButton';

const MyCats = () => {
  const [cats, setCats] = useState([]);
  const [selectedCat, setSelectedCat] = useState(null);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showModificationModal, setShowModificationModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    navigate('/my-cats');
  };

  const openCatDetailPage = (cat) => {
    setSelectedCat(cat);
    window.open(`/c/${cat.id}`, '_blank');
  }


  const openModificationModal = (cat) => {
    setSelectedCat(cat);
    setShowModificationModal(true);
  };

  const closeModificationModal = () => {
    setShowModificationModal(false);
    setSelectedCat(null);
    navigate('/my-cats');
  };

  const isUserLoggedIn = isAuthenticated();

  const fetchCats = async () => {
    if (!isUserLoggedIn) {
      navigate('/login?pre=my-cats');
      return;
    }

    try {
      // Use our API utility function
      const data = await get('/api/my-cats/');
      setCats(data);
    } catch (error) {
      console.error('Error fetching cats:', error);
      message.error('Failed to fetch cats');
    }
  };

  useEffect(() => {
    fetchCats();
  }, [isUserLoggedIn]);

  const handleRegisterSuccess = () => {
    fetchCats();
  };

  const handleUpdate = () => {
    fetchCats();
  };

  return (
    <div className="splide-wrapper">
      <div className="header-container">
        <h1 className="mycat-header">我的猫咪</h1>
      </div>
      <Splide
        options={{
          drag: 'free',
          snap: true,
          perPage: 3,
        }}
      >
        {cats.map(cat => (
          // <SplideSlide key={cat.id} onClick={() => openModificationModal(cat)}>
          <SplideSlide key={cat.id} onClick={() => openCatDetailPage(cat)}>

            <div className="cat-id-card-container">
              <CatIDCard cat={cat} />
            </div>
          </SplideSlide>
        ))}
      </Splide>
      <div className='register-cat-wrapper'>
        <GradientButton onClick={openModal} className="register-cat-button" type="primary">
          注册猫咪
        </GradientButton>
      </div>

      <Modal
        title="注册猫咪"
        open={showModal}
        onCancel={closeModal}
        footer={null}
        width={1000}
        destroyOnClose={true}
      >
        <CatRegistration onRegisterSuccess={handleRegisterSuccess} onClose={closeModal} />
      </Modal>
      {selectedCat && (
        <CatModification
          visible={showModificationModal}
          onClose={closeModificationModal}
          cat={selectedCat}
          onUpdate={handleUpdate}
        />
      )}
    </div>
  );
};

export default MyCats;
